import { InventoryLocationDto } from "../models"

export const ACTION_TYPES = {
    FETCH_LISTING : "FETCH_INVENTORY_LOCATIONS" as const,
    FETCH_LISTING_SUCCESS: "FETCH_INVENTORY_LOCATIONS_SUCCESS" as const,
    SUBMIT: "SUBMIT_INVENTORY_LOCATION" as const,
    SET_NAME: "SET_STOCK_INVENTORY_NAME" as const,
    SET_LOCATION_IDS: "SET_LOCATION_IDS" as const,
    SET_FROM_LISTING: "SET_INVENTORY_LOCATION_FROM_LISTING" as const,
    CLEAR_LOCATION: "CLEAR_INVENTORY_LOCATION" as const,
    SUBMIT_SUCCESS: "SUBMIT_INVENTORY_LOCATION_SUCCESS" as const,
    SUBMIT_FAIL: "SUBMIT_INVENTORY_LOCATION_FAIL" as const,
    DELETE: "DELETE_INVENTORY_LOCATION" as const,
    DELETE_SUCCESS: "DELETE_INVENTORY_LOCATION_SUCCESS" as const,
    DELETE_FAIL: "DELETE_INVENTORY_LOCATION_FAIL" as const,
    SET_INVENTORY_LOCATION: "SET_INVENTORY_LOCATION" as const
}

export type Actions =
    | { type: typeof ACTION_TYPES.FETCH_LISTING, payload: string }
    | { type: typeof ACTION_TYPES.FETCH_LISTING_SUCCESS, payload: InventoryLocationDto[] }
    | { type: typeof ACTION_TYPES.SUBMIT}
    | { type: typeof ACTION_TYPES.SET_NAME, payload: string }
    | { type: typeof ACTION_TYPES.SET_LOCATION_IDS, payload: string[] }
    | { type: typeof ACTION_TYPES.SET_FROM_LISTING, payload: string}
    | { type: typeof ACTION_TYPES.CLEAR_LOCATION}
    | { type: typeof ACTION_TYPES.SUBMIT_SUCCESS}
    | { type: typeof ACTION_TYPES.SUBMIT_FAIL, payload: string}
    | { type: typeof ACTION_TYPES.DELETE}
    | { type: typeof ACTION_TYPES.DELETE_SUCCESS}
    | { type: typeof ACTION_TYPES.DELETE_FAIL, payload: string}
    | { type: typeof ACTION_TYPES.SET_INVENTORY_LOCATION, payload: InventoryLocationDto}



// WEBPACK FOOTER //
// ./src/state/inventory/location/actions/types.ts